import {
  Instance as SummaryInstance,
  PatchOperationProps,
  PatchResourcesBody,
  ResourceType,
} from '../types';
import { buildPatchFieldBody } from './buildPatchFieldBody';
import { buildPatchProductBody } from './buildPatchProductBody';
import { groupInstances } from './groupInstances';
import { patchOperations } from '../api';

export const patchRelevantOperations = ({
  selectedMasterProductId,
  selectedInstances,
  activeResourceType,
  ignore = false,
  autoMappingEnabled,
  productToMap,
  orgId,
}: PatchOperationProps) => {
  const prod_id = selectedMasterProductId || '';

  const key = ResourceType.field === activeResourceType ? 'fields' : 'products';

  const mappedInstances = selectedInstances.map((instance: SummaryInstance) => {
    const { changes, undo_changes } =
      ResourceType.field === activeResourceType
        ? buildPatchFieldBody(instance, prod_id, ignore)
        : buildPatchProductBody(instance, prod_id, productToMap);

    const body: PatchResourcesBody = {
      operation_ids: [instance.parent_operation.id],
      mapping: {
        [key]: changes,
      },
      auto_mapping_enabled: autoMappingEnabled,
    };

    const undo: PatchResourcesBody = {
      ...body,
      mapping: { ...body.mapping, [key]: undo_changes },
    };
    return { body, undo };
  });

  const bodies = mappedInstances.flatMap((inst) => inst.body);
  const undo = mappedInstances.flatMap((inst) => inst.undo);

  const patches = groupInstances(bodies, key, autoMappingEnabled).map((instance) => {
    return new Promise<any>((resolve: any) => {
      patchOperations(instance, orgId).then((response: any) =>
        resolve({ instance, response, undo }),
      );
    });
  });

  return Promise.all(patches);
};
